import React, { useState, useEffect } from "react";
import logo from "../assets/Images/new_logo.jpg";
import { Link, NavLink } from "react-router-dom";
import Loader from "../Components/Loader";
import axios from "axios";
import { Config } from "../Config";

const Navbar = () => {
  const [stickyNavbar, setStickyNavbar] = useState(false);
  const [mobileMenu, setMobileMenu] = useState(false);
  const [contactSection, setContactSection] = useState({});

  window.addEventListener("scroll", () => {
    if (window.scrollY > 100) {
      setStickyNavbar(true);
    } else {
      setStickyNavbar(false);
    }
  });  

  useEffect(() => {
    axios.get(`${Config.apiUrl}/contactpage`,
      {
        headers: {
          //'Authorization': 'Bearer ',
          'Content-Type': 'application/json'
        }
      })
      .then(response => {
        const data = response.data.contact_page;
        setContactSection(data.contact_section);
      })
      .catch(error => {
        console.error('There was a problem fetching the data:', error);
      });
  }, []);

  // Get the height of the entire document
  const fullPageHeight = Math.max(
    document.body.scrollHeight, document.body.offsetHeight,
    document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight
  );

  return (
    <div className="border-bottom">
      <nav
        className={`pd-navbar shadow ${stickyNavbar ? fullPageHeight >= 900 ? "skicky-navbar" : "absolute-navbar" : ""
          }`}
      >
        <div className=" bg-blue py-2 top-contact">
          <div className="d-md-flex justify-content-md-end justify-content-center">
            <div className="mx-md-3 width-100">
              <i className="bi bi-telephone-fill text-white me-2"></i>
              <a
                href={`tel:${contactSection.contact_numbers}`}
                className="text-light text-decoration-none"
              >
                {contactSection.contact_numbers}
              </a>
            </div>
            <div className="mx-md-3 width-100">
              <i className="bi bi-envelope-fill text-white me-2"></i>
              <a
                href={`mailto:${contactSection.contact_mails}`}
                className="text-light text-decoration-none"
              >
                {contactSection.contact_mails}
              </a>
            </div>
          </div>
        </div>
        <div className="container-box ">
          <div className="row justify-space-between align-items-end ">
            <div className="col-md-3 col-6 text-md-start ">
              <Link to={`${Config.appUrl}`} className="navbar-brand">
                <img
                  src={logo}
                  alt="Logo"
                  className="logo"
                  onClick={() => window.scrollTo(0, 0)}
                ></img>
              </Link>
            </div>
            <div className="col-md-9 col-6 text-end position-relative">
              <ul className={`navlinks ${mobileMenu && "show-menu"}`}>
                {/*  */}
                <li>
                  <NavLink to={`${Config.appUrl}`}>HOME</NavLink>
                </li>

                <li>
                  <NavLink
                    to={`${Config.appUrl}all-projects`}
                    state={{
                      sector: "I",
                    }}
                  >
                    Projects
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    to={`${Config.appUrl}affordable/policy`}
                    state={{
                      sector: "I",
                    }}
                  >
                    Housing Policy
                  </NavLink>
                </li>

                <li>
                  <NavLink to={`${Config.appUrl}get-in-touch`} className="button text-white rounded-5">Contact Us</NavLink>
                </li>
              </ul>
              <i
                className={`bi bi-${mobileMenu ? "x" : "list"} fs-2 menu-btn`}
                onClick={() => setMobileMenu(!mobileMenu)}
              ></i>
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;